// Analytics event names
export const ANALYTICS_EVENTS = {
  // Audio device events
  AUDIO_DEVICE_STATE_CHANGED: 'audio_device_state_changed',
  AUDIO_SETTINGS_SAVED: 'audio_settings_saved',

  // Home screen events
  HOME_OPEN_RESULT: 'home_open_result',
  HOME_START_CONSULTATION: 'home_start_consultation',
  HOME_SELECT_ENTER_PATIENT_ID: 'home_select_enter_patient_id',
  HOME_START_CONSULTATION_MANUAL_PATIENT_ID: 'home_start_consultation_manual_patient_id',

  // Result screen events
  RESULT_CLOSE: 'result_close',
  RESULT_TRANSFER_SUMMARY: 'result_transfer_summary',
  RESULT_SECTION_COPIED: 'result_section_copied',
  RESULT_SECTION_CHECKBOX_TOGGLED: 'result_section_checkbox_toggled',
  RESULT_VITAL_PARAMETER_TOGGLED: 'result_vital_parameter_toggled',
  RESULT_DIAGNOSIS_SECTION_TOGGLED: 'result_diagnosis_section_toggled',
  RESULT_DIAGNOSIS_ENTRY_TOGGLED: 'result_diagnosis_entry_toggled',
  RESULT_EBM_CODE_TOGGLED: 'result_ebm_code_toggled',
  RESULT_EBM_SECTION_TOGGLED: 'result_ebm_section_toggled',
  RESULT_SUGGESTIONS_RETRY: 'result_suggestions_retry',

  // Patient/Recording screen events
  PATIENT_DATA_LOADED: 'patient_data_loaded',
  PATIENT_START_RECORDING: 'patient_start_recording',
  PATIENT_START_WITHOUT_RECORDING: 'patient_start_without_recording',
  PATIENT_STOP_RECORDING: 'patient_stop_recording',
  PATIENT_PAUSE_RECORDING: 'patient_pause_recording',
  PATIENT_AUTO_PAUSE_RECORDING: 'patient_auto_pause_recording',
  PATIENT_RESUME_RECORDING: 'patient_resume_recording',
  PATIENT_END_TRANSCRIBE_RECORDING: 'patient_end_transcribe_recording',
  PATIENT_DISCARD_RECORDING: 'patient_discard_recording',
  RECORDING_LANGUAGE_CHANGED: 'recording_language_changed',
  IMMUNIZATION_ADDED: 'immunization_added',

  // Feedback events
  FEEDBACK_OPENED: 'feedback_opened',
  FEEDBACK_BUTTON_CLICKED: 'feedback_button_clicked',
  FEEDBACK_HELPFULNESS_CLICKED: 'feedback_helpfulness_clicked',
  FEEDBACK_FORM_SUBMITTED: 'feedback_form_submitted',
  FEEDBACK_FORM_CLOSED: 'feedback_form_closed',

  // TitleBar events
  TITLEBAR_BACK_BUTTON_CLICKED: 'titlebar_back_button_clicked',
  TITLEBAR_MENU_OPENED: 'titlebar_menu_opened',
  TITLEBAR_MENU_ITEM_CLICKED: 'titlebar_menu_item_clicked',
  TITLEBAR_PAUSED_CONSULTATIONS_OPENED: 'titlebar_paused_consultations_opened',
  TITLEBAR_FAILED_TRANSMISSIONS_OPENED: 'titlebar_failed_transmissions_opened',

  // AMBOSS integration events
  AMBOSS_OPENED: 'amboss_opened',
  AMBOSS_AIMODE_SENT: 'amboss_aimode_sent',
  AMBOSS_SEARCH_SENT: 'amboss_search_sent',
  AMBOSS_CLOSED: 'amboss_closed',
} as const;
